import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_RUN_AGGREGATES,
  SET_KEYSTONE_RUN_AGGREGATES_FILTER,
  SET_KEYSTONE_RUN_AGGREGATES_LOADING
} from '../actions/keystoneActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

const DEFAULT_INSTANCE_ID = 'main';

const DEFAULT_STATE = {
  instances: {
    [DEFAULT_INSTANCE_ID]: {
      aggregates: [],
      pendingFilters: {},
      isLoading: false
    }
  }
};

export default function keystoneRunAggregatesReducer(
  state: Partial<any> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  const instanceId = (action as any).instanceId || DEFAULT_INSTANCE_ID;
  switch (action.type) {
    case SET_KEYSTONE_RUN_AGGREGATES: {
      state.instances[instanceId].aggregates = action.payload;
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceId]: {
            ...state.instances[instanceId],
            ...action.payload,
            pendingFilters: {
              ...action.payload.ui
            }
          }
        }
      };
    }
    case SET_KEYSTONE_RUN_AGGREGATES_FILTER: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceId]: {
            ...state.instances[instanceId],
            pendingFilters: {
              ...state.pendingFilters,
              ...action.payload
            }
          }
        }
      };
    }
    case SET_KEYSTONE_RUN_AGGREGATES_LOADING: {
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceId]: {
            ...state.instances[instanceId],
            isLoading: action.payload
          }
        }
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
